import { render } from "./WCEmptyCart.vue?vue&type=template&id=27935fa8"
import script from "./WCEmptyCart.vue?vue&type=script&lang=js"
export * from "./WCEmptyCart.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__